module.exports = __webpack_public_path__ + "img/goodsclose3.ad02da6b.png";